import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UploadExcelFacade } from '@mode/dataset/excel/contract';
import { ExcelClientService } from '@mode/dataset/excel/data-access';
import { UploadExcelDialogService } from './upload-excel-dialog.service';
import { AccountFacade } from '@mode/accounts/contract';
import { ExcelSheetFacade } from '@mode/dataset/contract';

@Injectable()
export class UploadExcelService implements UploadExcelFacade {
  constructor(
    private excelClientService: ExcelClientService,
    private accountFacade: AccountFacade,
    private excelSheetFacade: ExcelSheetFacade,
    private uploadExcelDialogService: UploadExcelDialogService
  ) {}

  async launchDialog() {
    const accountId = (await firstValueFrom(this.accountFacade.currentOrg$)).username;
    const { layout, token } = await firstValueFrom(this.excelClientService.getExcelReport(accountId));

    this.uploadExcelDialogService.open({
      confirmAction: ({ tab, name, description, spreadsheetId, worksheetId, url }) => {
        this.excelSheetFacade.createExcelSheetDataset({
          tab,
          name,
          description,
          spreadsheetId,
          worksheetId,
          url,
          accountId,
          token,
          layout,
        });
      },
    });
  }

  getExcelConnection(username: string, token: string) {
    return this.excelClientService.getExcelConnection(username, token);
  }

  getExcelSpreadsheets(username: string, token: string, searchText?: string) {
    return this.excelClientService.getExcelSpreadsheets(username, token, searchText);
  }

  getExcelWorksheets(username: string, token: string, spreadsheetId: string) {
    return this.excelClientService.getExcelWorksheets(username, token, spreadsheetId);
  }

  loadMoreSpreadsheets(nextPageUrl: string, currentSpreadsheets: readonly any[]) {
    return this.excelClientService.loadMoreSpreadsheets(nextPageUrl, currentSpreadsheets);
  }
}
